import React, { Component, ErrorInfo, ReactNode } from 'react';

import ErrorDisplay from 'components/Generics/Error/Error';
import { ErrorContext } from './ErrorContext';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error;
}

class ErrorBoundary extends Component<Props, State> {
    // eslint-disable-next-line react/state-in-constructor
    public state: State = {
        hasError: false,
        error: new Error(),
    };

    public static getDerivedStateFromError(_: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error: _ };
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        // eslint-disable-next-line no-console
        console.error('Uncaught error:', error, errorInfo);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public render() {
        const { hasError, error } = this.state;
        const { children } = this.props;
        if (hasError) {
            return <ErrorDisplay />;
        }

        return (
            <ErrorContext.Provider
                value={{
                    error: hasError ? error : null,
                    setError: (newError) => {
                        this.setState({
                            hasError: newError !== null,
                            error: newError ?? error,
                        });
                    },
                }}
            >
                {children}
            </ErrorContext.Provider>
        );
    }
}

export default ErrorBoundary;
